/**
 * SidebarSubnavigationCollapse
 */
import * as React from 'react';

// Styles
import './styles.scss';

interface Props {
    expanded?: boolean;
    children: React.Node;
}

export default class SidebarSubnavigationCollapse extends React.PureComponent<
    Props,
    State
> {
    render() {
        const { expanded, children } = this.props;
        return (
            <div
                className={[
                    'sidebar-subnavigation-collapse',
                    expanded ? 'expanded' : ''
                ].join(' ')}
            >
                {children}
            </div>
        );
    }
}
